/* ==========================================================================
   pdp-swatch-medida.js  --  MAHA  --  2026-09-02
   --------------------------------------------------------------------------
   QUE HACE
   Swatch King pinta bajo cada muestra el valor de opcion COMPLETO. Como en MAHA
   la medida va al final ("Plato Trinche 27 cm"), y el preset recorta por la
   derecha con ellipsis a 89 px, la etiqueta nativa acaba ensenando
   "Plato Trinche ..." y escondiendo justo el dato que interesa.

   Este archivo reduce ese texto a su medida: "27 cm", "450 ml", "36x24 cm".
   Cabe en un renglon, no hay que envolver, y el crecimiento vertical se queda
   en el que ya se midio.

   COMO LO HACE  --  la regla de esta tarea
   Anade un <span data-maha-medida> HERMANO del <p> de la app, dentro del mismo
   contenedor. NO toca el <p>, ni su class, ni data-value, ni ningun atributo
   ARIA, ni el <li>, ni el <ul>. El <p> se oculta desde CSS
   (assets/pdp-swatch-medida.css), no desde aqui.

   NO SE CITA NINGUN IDENTIFICADOR INESTABLE. Ni `swatch-preset-744259` (id de
   fila del preset en la BD de la app) ni `data-group-index` (es la POSICION del
   grupo entre los que haya: anadir uno los corre todos). Solo el nombre del
   custom element y las clases funcionales.

   EL TOPE NO SE DUPLICA AQUI
   El umbral de "3 o mas grupos" vive UNA sola vez, en el selector raiz de
   assets/pdp-swatch-medida.css. Este archivo no lo reimplementa: lo consulta,
   leyendo la custom property `--maha-destapa` que aquella hoja publica sobre el
   `.swatch-single` destapado. Si no vale 1, aqui no se escribe nada y se retira
   cualquier <span> anterior. Ver funcion `destapado()`.

   DEGRADACION SEGURA
   - Si la app deja de emitir `.swatch-img-text-adjacent`, no hay donde escribir:
     no se anade nada, y el CSS tampoco casa. Queda la ficha de hoy.
   - Si algo lanza, se traga en un try/catch por pasada. Un throw suelto en esta
     pagina puede cortar a otros suscriptores (FoxTheme.pubsub.publish no lleva
     try/catch propio), asi que aqui nada escapa.
   - Si ningun patron casa, NO se recorta: se deja el valor completo de la app.
     Un color nunca se convierte en cifra.

   NO PUEDE ROMPER EL SELECTOR
   El manejador de la app hace `for (t = e.target; t.hasAttribute("swatch-inside");)
   t = t.parentNode;`. Por eso el <span> lleva swatch-inside="true": si alguna vez
   fuera el blanco del clic, la app sube al nodo correcto igual que con el <p>.
   Ademas el CSS le pone pointer-events:none, asi que en la practica nunca lo es.
   ========================================================================== */
(function () {
  'use strict';

  var RAIZ = 'variant-swatch-king';
  /* MAHA 2026-09-09 -- SWATCH-MEDIDA-DESTAPAR-LO-QUE-YA-EXISTE
     Medido en vivo: la app NUNCA emite `.swatch-img-text-adjacent` en esta
     tienda (0 de 8 contenedores en la ficha de prueba). La clase real que
     envuelve el <p> de cada muestra es `.swatch-img-text` (con un sufijo de
     estado, hoy "-hidden"). Se lee la clase base, estable frente a ese sufijo,
     en vez de la variante que nunca aparece. Ver tambien pdp-swatch-medida.css,
     bloque "EL TOPE", mismo cambio y misma fecha. */
  var CONTENEDOR = '.swatch-img-text';
  var MARCA = 'data-maha-medida';
  var ORIGEN = 'data-maha-src';
  /* MAHA 2026-09-14 -- SWATCH-LA-MEDIDA-SOLO-VALE-SI-DISTINGUE, CAMBIO 2 */
  var TAMANO_ATTR = 'data-maha-tamano';

  /* ------------------------------------------------------------------------
     LA GUARDIA: un valor con LISTA de numeros no se recorta NUNCA.
     "Tapa domo con perforacion 9, 12, 16 y 20 oz" no mide 20 oz: son cuatro
     calibres. Recortarlo seria decir algo falso, que es peor que no decir nada.
     Tambien atrapa los separadores de millar y las comas decimales mal escritas
     ("Caja 2, 45 oz / 1,330 ml"), donde tampoco hay una medida limpia que sacar.

     Se admiten hasta 6 caracteres no numericos entre los dos numeros, para que
     tambien caiga "450 ml / 15 oz) y 350 ml" -- una lista de verdad, con la
     unidad de por medio. La barra "/" NO cuenta como separador de lista: separa
     la MISMA medida en dos unidades ("40.5 cm / 16\"") y ademas aparece en las
     fracciones de pulgada ("12 1/2\"").
     ------------------------------------------------------------------------ */
  var LISTA = /\d[^\d]{0,6}?(?:,|\by\b)[^\d]{0,6}?\d/i;

  /* Segunda guardia: VARIAS MEDIDAS SUELTAS.
     El texto de una muestra de grupo puede ser el titulo entero del producto
     ("... Alto 5.5 cm, largo 21 cm, ancho 7 cm"). Ahi no hay "una" medida: hay
     tres, y quedarse con la primera dice "5.5 cm" de una caja de 21 cm. Regla:
     si aparecen DOS O MAS pares numero+longitud, no se recorta.
     Ojo: "Charola 28 x 18.5 cm" tiene un solo par (la unidad va una sola vez),
     asi que las medidas compuestas P1/P2 siguen pasando. */
  var LONGITUDES = /(\d+(?:[.]\d+)?)\s*(cm|mm)\b/gi;
  /* Y si se repite la MISMA unidad de volumen son dos capacidades distintas,
     no una equivalencia: "30 OZ / 1 L" si es la misma medida en dos unidades y
     debe pasar; "500 ml ... 225 ml" no. */
  var VOLUMENES = /(\d+(?:[.]\d+)?)\s*(ml|lts|lt|l|oz|onzas|onza)\b/gi;

  function variasMedidas(s) {
    var m, nLong = 0, unidades = {};
    LONGITUDES.lastIndex = 0;
    while ((m = LONGITUDES.exec(s)) !== null) nLong++;
    if (nLong >= 2) return true;
    VOLUMENES.lastIndex = 0;
    while ((m = VOLUMENES.exec(s)) !== null) {
      var u = m[2].toLowerCase();
      if (u === 'onza' || u === 'onzas') u = 'oz';
      if (u === 'lts' || u === 'lt') u = 'l';
      unidades[u] = (unidades[u] || 0) + 1;
      if (unidades[u] >= 2) return true;
    }
    return false;
  }

  /* ------------------------------------------------------------------------
     LOS PATRONES, en orden de aplicacion: el primero que casa, gana.
     Las medidas compuestas van ANTES que las simples, porque "33x33x2 cm" con
     una regla de numero suelto devuelve "2".
     Cobertura medida sobre los 1,114 valores de opcion que la app pinta como
     muestra: 83.4 %.
     ------------------------------------------------------------------------ */
  var PATRONES = [
    /* P1  3D   "Tabla para picar Amarilla 45 x 30 x 1.27 cm"  -> 45 x 30 x 1.27 cm */
    { id: 'P1', re: /(\d+(?:[.]\d+)?)\s*[x×]\s*(\d+(?:[.]\d+)?)\s*[x×]\s*(\d+(?:[.]\d+)?)\s*(cm|mm)\b/i, tipo: 'bloque' },
    /* P2  2D   "Plato ovalado 36x24 cm"                        -> 36x24 cm        */
    { id: 'P2', re: /(\d+(?:[.]\d+)?)\s*[x×]\s*(\d+(?:[.]\d+)?)\s*(cm|mm)\b/i, tipo: 'bloque' },
    /* P5  longitud  "Plato Trinche 27 cm" / "Frasco 26.7 cm"   -> 27 cm / 26.7 cm */
    { id: 'P5', re: /(\d+(?:[.]\d+)?)\s*(cm|mm)\b/i, tipo: 'num_unidad' },
    /* P4  volumen   "Frasco 50 ML" / "Tazon 450 ml"            -> 50 ml / 450 ml  */
    { id: 'P4', re: /(\d+(?:[.]\d+)?)\s*(ml|lts|lt|l)\b/i, tipo: 'num_unidad' },
    /* P6  onzas     "Vaso 16 oz"                               -> 16 oz           */
    { id: 'P6', re: /(\d+(?:[.]\d+)?)\s*(oz|onzas|onza)\b/i, tipo: 'num_unidad' },
    /* P7  pulgadas  'Inserto profundidad 2.5"' / '12 1/2"'     -> 2.5" / 12 1/2"  */
    { id: 'P7', re: /(\d+(?:\s+\d+\/\d+)?|\d+\/\d+)\s*(?:"|''|pulg\.?|in\b)/, tipo: 'bloque' }
  ];

  /* El simbolo del litro va en mayuscula ("1 L"); el resto, en minuscula. */
  function unidad(u) {
    var b = String(u).toLowerCase();
    if (b === 'l' || b === 'lt' || b === 'lts') return 'L';
    if (b === 'onza' || b === 'onzas') return 'oz';
    return b;
  }

  /**
   * Reduce un valor de opcion a su medida.
   * @returns {string|null} la medida, o null si no hay que recortar.
   */
  function recorta(valorCrudo) {
    /* doble espacio y saltos: el catalogo trae "Plato trinche  Horeca 20 cm" */
    var s = String(valorCrudo || '').replace(/\s+/g, ' ').trim();
    if (!s) return null;
    if (LISTA.test(s)) return null;                 /* las guardias, antes que nada */
    if (variasMedidas(s)) return null;

    for (var i = 0; i < PATRONES.length; i++) {
      var p = PATRONES[i];
      var m = s.match(p.re);
      if (!m) continue;
      var salida;
      if (p.tipo === 'num_unidad') {
        salida = m[1] + ' ' + unidad(m[2]);          /* "50 ML" -> "50 ml", "1 l" -> "1 L" */
      } else {
        salida = m[0].replace(/\s+/g, ' ').trim();
        salida = salida.replace(/(cm|mm)$/i, function (u) { return u.toLowerCase(); });
        salida = salida.replace(/\s*X\s*/g, ' x ').replace(/\s+/g, ' ').trim();
      }
      /* si el recorte no ahorra nada, no vale la pena sustituir nada */
      if (salida.length >= s.length) return null;
      return salida;
    }
    return null;
  }

  /* ------------------------------------------------------------------------
     MAHA 2026-09-09 -- SWATCH-MEDIDA-DEVOLVER-EL-CUADRO-Y-EL-NOMBRE-CORTO
     Funcion NUEVA, al lado de recorta() -- no la toca ni comparte sus 7
     patrones ni sus 2 guardias, porque el problema es otro: un valor de color
     ("Trinche blanco 27 cm") no tiene unidad que extraer, tiene una PALABRA
     que lo distingue de sus hermanos del mismo grupo ("Trinche rosa 27 cm",
     "Trinche amarillo 27 cm"). Se le quita a cada valor lo que TODOS los del
     grupo comparten al inicio y al final (por palabra completa, nunca a la
     mitad), y queda solo lo distinto. Si a alguno no le queda nada, esa
     etiqueta se omite (mejor vacio que basura) -- el ancho maximo y la
     elipsis de una sola linea ya los da [data-maha-medida] en el CSS, el
     mismo tratamiento que ya tienen las medidas.
     ------------------------------------------------------------------------ */
  function palabras(s) {
    return String(s || '').trim().split(/\s+/).filter(function (w) { return w.length > 0; });
  }

  function recortaComunGrupo(valoresCrudos) {
    var listas = [], i, j;
    for (i = 0; i < valoresCrudos.length; i++) listas.push(palabras(valoresCrudos[i]));
    if (!listas.length) return [];

    var minLen = listas[0].length;
    for (i = 1; i < listas.length; i++) { if (listas[i].length < minLen) minLen = listas[i].length; }

    var prefijoLen = 0;
    for (i = 0; i < minLen; i++) {
      var wPre = listas[0][i], igualesPre = true;
      for (j = 1; j < listas.length; j++) { if (listas[j][i] !== wPre) { igualesPre = false; break; } }
      if (!igualesPre) break;
      prefijoLen++;
    }

    var sufijoLen = 0;
    for (i = 0; i < minLen - prefijoLen; i++) {
      var wSuf = listas[0][listas[0].length - 1 - i], igualesSuf = true;
      for (j = 1; j < listas.length; j++) { if (listas[j][listas[j].length - 1 - i] !== wSuf) { igualesSuf = false; break; } }
      if (!igualesSuf) break;
      sufijoLen++;
    }

    var salidas = [];
    for (i = 0; i < listas.length; i++) {
      var l = listas[i];
      var fin = l.length - sufijoLen;
      if (fin <= prefijoLen) { salidas.push(null); continue; }
      var restante = l.slice(prefijoLen, fin).join(' ').trim();
      if (!restante) { salidas.push(null); continue; }
      salidas.push(restante.charAt(0).toUpperCase() + restante.slice(1));
    }
    return salidas;
  }

  /* Deteccion del grupo de color: por el NOMBRE que el propio comerciante le
     dio a la opcion (atributo estructural [option-name] de la app), no por un
     indice ni un id de preset -- esos SI son inestables, ver cabecera. */
  /* MAHA 2026-09-09 -- SWATCH-TEXTO-HIBRIDO-POR-FILA: ¿CABE?
     No se estima por numero de caracteres: "Plato hondo 750 ml" y
     "Trinche 27 cm" tienen anchos muy distintos con letras parecidas. Se MIDE el
     renderizado real.
     COMO: una sonda con el atributo data-maha-medida (para que le apliquen
     EXACTAMENTE las mismas reglas del CSS: familia, 11px, peso 600,
     line-height 120%, padding lateral, break-word) metida en el mismo
     contenedor, asi hereda el mismo ancho que tendria la etiqueta de verdad.
     Se le QUITA el clamp de renglones para que crezca a su alto natural, y se
     compara ese alto contra el tope. Comparar scrollHeight con clientHeight
     teniendo el clamp puesto seria mas corto de escribir pero depende de como
     cada motor reporta el alto de un -webkit-box recortado; medir el alto libre
     no depende de eso.
     VISIBILIDAD: la sonda se crea, se mide y se retira DENTRO de la misma
     funcion, sin ceder el hilo. El navegador no pinta a mitad de una tarea, asi
     que el usuario no ve nada aparecer ni cambiar.
     Devuelve true solo si TODOS los textos caben.

     MAHA 2026-09-10 -- SWATCH-EL-NOMBRE-COMPLETO-DENTRO-DEL-MARCO: el tope
     paso de 2 a 3 renglones, igual que el `-webkit-line-clamp` real que ya
     declara [data-maha-medida] en el CSS. Los dos numeros tienen que
     coincidir siempre: si la sonda mide contra un tope distinto del que el
     CSS aplica de verdad, esta funcion puede decir "cabe" para algo que el
     usuario ve cortado con puntos suspensivos, o "no cabe" para algo que
     habria entrado bien. */
  function cabenTodos(cont, textos) {
    if (!cont || !textos || !textos.length) return false;
    var sonda = document.createElement('span');
    sonda.setAttribute(MARCA, '');
    sonda.setAttribute('data-maha-sonda', '');
    sonda.setAttribute('aria-hidden', 'true');
    sonda.style.visibility = 'hidden';
    sonda.style.position = 'static';
    /* sin recorte: que crezca lo que necesite */
    sonda.style.webkitLineClamp = 'unset';
    sonda.style.lineClamp = 'unset';
    sonda.style.display = 'block';
    sonda.style.overflow = 'visible';
    sonda.style.maxHeight = 'none';
    cont.appendChild(sonda);

    var cabe = true;
    try {
      var cs = window.getComputedStyle(sonda);
      var lh = parseFloat(cs.lineHeight);
      if (!lh || isNaN(lh)) lh = parseFloat(cs.fontSize) * 1.2 || 13.2;
      var tope = lh * 3 + 1;            /* 3 renglones, con 1 px de holgura */
      for (var i = 0; i < textos.length; i++) {
        if (textos[i] === null) continue;
        sonda.textContent = textos[i];
        if (sonda.getBoundingClientRect().height > tope) { cabe = false; break; }
      }
    } catch (e) {
      cabe = false;                     /* si no se puede medir, no se arriesga */
    }
    if (sonda.parentNode) sonda.parentNode.removeChild(sonda);
    return cabe;
  }

  /* MAHA 2026-09-14 -- SWATCH-LA-MEDIDA-SOLO-VALE-SI-DISTINGUE, CAMBIO 2
     cabenTodos() mide el BLOQUE completo, a 11px fijo, contra el ALTO de 3
     renglones -- decide si hace falta envolver o acortar. Esta funcion es
     otra cosa: palabra por palabra (aqui SI puede haber salto de renglon
     entre palabras; lo unico que no puede pasar es que UNA palabra se parta
     por dentro), ¿cabe cada una en un renglon propio, al TAMANO dado, contra
     el ANCHO real del cuadro? Se usa despues de que pintaSelector() ya
     decidio el texto final, para elegir con que tamano de letra (11, 10 o 9)
     se pinta ESA etiqueta en particular -- ver el bucle final y el CSS,
     bloque "CAMBIO 2". `tamanoAtributo` es null para probar el tamano base
     (11px, el que ya da la regla [data-maha-medida] sin marca extra) o '10'
     / '9' para probar exactamente el tamano que pondria esa marca -- asi la
     sonda y el resultado real nunca pueden discrepar (mismo problema que ya
     resolvio cabenTodos con su propio tope, mismo remedio: preguntarle al
     CSS, no repetir el numero a mano). No toca cabenTodos ni su sonda. */
  function palabraMasAnchaCabe(cont, texto, tamanoAtributo) {
    var ps = palabras(texto);
    if (!ps.length) return { cabe: true, palabra: null };
    if (!cont || !cont.clientWidth) return { cabe: true, palabra: null };
    var sonda = document.createElement('span');
    sonda.setAttribute(MARCA, '');
    if (tamanoAtributo !== null) sonda.setAttribute(TAMANO_ATTR, tamanoAtributo);
    sonda.setAttribute('data-maha-sonda', '');
    sonda.setAttribute('aria-hidden', 'true');
    sonda.style.visibility = 'hidden';
    sonda.style.position = 'absolute';
    sonda.style.whiteSpace = 'nowrap';
    sonda.style.display = 'inline-block';
    sonda.style.webkitLineClamp = 'unset';
    sonda.style.lineClamp = 'unset';
    sonda.style.overflow = 'visible';
    sonda.style.maxHeight = 'none';
    sonda.style.maxWidth = 'none';
    cont.appendChild(sonda);

    var anchoTope = cont.clientWidth;
    var resultado = { cabe: true, palabra: null };
    try {
      for (var i = 0; i < ps.length; i++) {
        sonda.textContent = ps[i];
        if (sonda.getBoundingClientRect().width > anchoTope) {
          resultado.cabe = false;
          resultado.palabra = ps[i];
          break;
        }
      }
    } catch (e) {
      resultado.cabe = false;
      resultado.palabra = ps[0];
    }
    if (sonda.parentNode) sonda.parentNode.removeChild(sonda);
    return resultado;
  }

  /* MAHA 2026-09-10 -- SWATCH-LOS-GRUPOS-DE-PRODUCTO-QUEDARON-SIN-NOMBRE
     Ultimo recurso cuando ni recorta() ni recortaComunGrupo() dejan nada que
     quepa: en vez de cortar con elipsis (puede partir una palabra a la
     mitad), se prueba con la sonda de cabenTodos() cuantas PALABRAS
     COMPLETAS del titulo caben, de mas a menos. Nunca corta dentro de una
     palabra y nunca devuelve null: si ni la primera palabra cabe (caso
     extremo), se usa esa primera palabra de todas formas -- el invariante
     duro es que ningun swatch se quede sin texto, ni siquiera en el peor
     caso. */
  function masLargoQueQuepa(cont, texto) {
    var ps = palabras(texto);
    if (!ps.length) return null;
    for (var n = ps.length; n >= 1; n--) {
      var candidato = ps.slice(0, n).join(' ');
      if (cabenTodos(cont, [candidato])) return candidato;
    }
    return ps[0];
  }

  function esGrupoColor(selector) {
    var contOpcion = selector.closest('[option-name]');
    var nombre = contOpcion ? contOpcion.getAttribute('option-name') : '';
    return /color/i.test(nombre || '');
  }

  /* MAHA 2026-09-14 -- TITULO-DE-LAS-FILAS-DE-GRUPO
     esGrupoColor() (arriba, sin tocar) solo mira el ATRIBUTO option-name --
     por eso nunca detecta la fila de color de TAVTERRAHT27C ni la de
     VZ210-05: las dos tienen option-name="empty", no "Color". Esta funcion
     es OTRA cosa, deliberadamente separada: mira el CONTENIDO (los valores
     crudos), reutilizando recortaComunGrupo() (sin tocar) para ver que le
     quedaria a cada muestra tras quitar el prefijo/sufijo comun del grupo.
     Es CONSERVADORA a proposito (decision explicita de Guillermo: "una fila
     sin titulo es aceptable; una titulada 'Color' cuando no son colores,
     no"): exige que TODOS y cada uno de los residuos sean UNA sola palabra
     Y que esa palabra este en la lista cerrada de abajo. Si UN SOLO valor
     no cumple -- residuo vacio, mas de una palabra, o palabra fuera de la
     lista -- toda la fila se queda sin titulo, igual que hoy. No decide
     nada sobre CUAL palabra usar como titulo (eso lo hace el ajuste del
     tema, ver tituloConfigurado()): solo responde si/no. */
  var COLORES_CONOCIDOS = ['azul', 'celeste', 'turquesa', 'aqua', 'menta', 'verde', 'oliva',
    'amarillo', 'mostaza', 'ocre', 'naranja', 'durazno', 'coral', 'rojo', 'vino', 'borgona',
    'rosa', 'fucsia', 'magenta', 'morado', 'lila', 'violeta', 'cafe', 'marron', 'chocolate',
    'beige', 'arena', 'crema', 'marfil', 'blanco', 'negro', 'gris', 'plata', 'plateado', 'plateada',
    'oro', 'dorado', 'dorada', 'cobre', 'bronce', 'perla', 'humo', 'salmon'];

  function normalizaColor(s) {
    return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').trim();
  }

  function esFilaDeColorSinNombre(valoresCrudos) {
    if (!valoresCrudos || valoresCrudos.length < 2) return false;
    var residuos = recortaComunGrupo(valoresCrudos);
    for (var i = 0; i < residuos.length; i++) {
      var r = residuos[i];
      if (r === null) return false;
      var ps = palabras(r);
      if (ps.length !== 1) return false;
      if (COLORES_CONOCIDOS.indexOf(normalizaColor(ps[0])) === -1) return false;
    }
    return true;
  }

  /* MAHA 2026-09-14 -- TITULO-DE-LAS-FILAS-DE-GRUPO
     Lee UNA sola vez (memoizado) el bloque #maha-group-labels que emite
     sections/main-product.liquid con los dos ajustes de tema
     (group_color_label / group_siblings_label). Si el ajuste esta vacio en
     el Personalizador, o el bloque no existe (tema viejo, o el archivo no
     llego a cargar), se devuelve null -- eso significa "sin titulo", el
     mismo comportamiento que hay hoy. */
  var _tituloCache = null;
  function tituloConfigurado(clave) {
    if (_tituloCache === null) {
      _tituloCache = { color: '', siblings: '', siblings_alt: '' };
      try {
        var nodo = document.getElementById('maha-group-labels');
        if (nodo) {
          var datos = JSON.parse(nodo.textContent || '{}');
          if (typeof datos.color === 'string') _tituloCache.color = datos.color.trim();
          if (typeof datos.siblings === 'string') _tituloCache.siblings = datos.siblings.trim();
          if (typeof datos.siblings_alt === 'string') _tituloCache.siblings_alt = datos.siblings_alt.trim();
        }
      } catch (e) { /* JSON invalido o ausente: se queda en "sin titulo" */ }
    }
    var v = _tituloCache[clave];
    return v ? v : null;
  }

  /* MAHA 2026-09-14 -- AJUSTE-TITULO-DUPLICADO-EN-LA-MISMA-PAGINA
     El titulo visible de CUALQUIER fila (con nombre real o sin el) siempre
     vive dentro de su <legend>: en las filas con nombre real es el propio
     texto plano de la app ("Seleccionar un Tamaño"); en las filas "empty"
     que ya procesamos en ESTA MISMA pasada, es el texto que esta funcion ya
     escribio en su <span> hijo (legend.textContent lo recoge igual, porque
     el span vive dentro del legend). Por eso basta con leer legend.textContent
     para detectar un choque contra CUALQUIER fila, sin importar de cual de
     los dos origenes salio. */
  function tituloVisibleDeGrupo(contOpcion) {
    var legend = contOpcion.querySelector('fieldset > legend');
    if (!legend) return '';
    return legend.textContent.replace(/\s+/g, ' ').trim();
  }

  /* Busca, dentro del MISMO widget (variant-swatch-king) de este producto,
     si algun OTRO grupo ya muestra exactamente este texto. Acotado al
     widget del producto (no a document entero) para no comparar contra un
     carrusel de productos relacionados que pudiera traer su propio
     variant-swatch-king en otra parte de la pagina. */
  function tituloYaExisteEnPagina(selector, candidato) {
    if (!candidato) return false;
    var raiz = selector.closest('variant-swatch-king');
    if (!raiz) return false;
    var grupos = raiz.querySelectorAll('[option-name]');
    for (var i = 0; i < grupos.length; i++) {
      if (tituloVisibleDeGrupo(grupos[i]) === candidato) return true;
    }
    return false;
  }

  /* MAHA 2026-09-14 -- TITULO-DE-LAS-FILAS-DE-GRUPO
     Escribe el titulo SOLO en filas sin nombre real (option-name="empty"
     exacto, sin distinguir mayusculas). Las filas con nombre real
     ("Tamaño", "Producto"...) no entran aqui ni se leen: la app ya pinta su
     propio texto ("Seleccionar un Tamaño") en un nodo de TEXTO PLANO
     distinto (el label de <legend>), no en este <span> -- este archivo no
     lo toca.

     DONDE SE ESCRIBE (revisado 2026-09-14, TITULO-DE-GRUPO-QUE-SE-VEA-IGUAL):
     NO se escribe en ".swatch-option-name" -- medido que ese span tiene su
     PROPIA regla en pdp-maha.css (font-size:12.5px, font-weight:700,
     color:var(--pdp-ink)), distinta de como se ve el titulo nativo
     ("Seleccionar un Tamaño"/"...Producto"), que la app escribe como TEXTO
     PLANO directo dentro de ".swatch-label-image" (el <label>), sin ningun
     span de por medio. Medido con CSS.getMatchedStylesForNode que el
     <label> en si -- MISMO elemento, MISMAS clases en la fila con nombre y
     en la fila "empty" -- ya sale con el estilo IDENTICO en las dos (14px /
     500 / negro / 22.4px): no hace falta ninguna regla CSS nueva, solo
     dejar de pasar por el span y escribir donde escribe el nativo. Como un
     nodo de texto suelto no se puede localizar de forma estable en pasadas
     futuras (no admite atributos), se usa un <span> SIN CLASE, marcado con
     el atributo data-maha-titulo-grupo (que ninguna hoja de estilos del
     tema selecciona) -- visualmente identico a un nodo de texto plano,
     porque no trae ninguna regla propia que pisar: hereda del <label> tal
     cual lo hace el texto nativo. El span original ".swatch-option-name"
     se deja intacto y vacio, exactamente como lo deja la app hoy.

     Prioridad: color (por atributo O por contenido) > "hermanos" (todo lo
     demas que no sea color ni fila de medida) > nada. Idempotente: no
     escribe si el texto deseado ya es el actual; si no hay titulo, quita el
     marcador en vez de dejarlo vacio. */
  function pintaTituloDeGrupo(selector, valoresCrudos) {
    var contOpcion = selector.closest('[option-name]');
    if (!contOpcion) return;
    var nombre = String(contOpcion.getAttribute('option-name') || '').trim().toLowerCase();
    if (nombre !== 'empty') return;

    var label = contOpcion.querySelector('.swatch-label-image');
    if (!label) return;

    var titulo = null;
    if (esGrupoColor(selector) || esFilaDeColorSinNombre(valoresCrudos)) {
      titulo = tituloConfigurado('color');
    } else if (!esFilaDeMedida(selector, valoresCrudos)) {
      /* MAHA 2026-09-14 -- AJUSTE-TITULO-DUPLICADO-EN-LA-MISMA-PAGINA
         Si el titulo de "hermanos" por defecto ya aparece en la pagina --
         tipico cuando el producto YA tiene una fila con nombre real llamada
         literalmente "Producto" -- se usa el alterno en su lugar. El titulo
         de la fila con nombre real NUNCA cede: esta fila (sin nombre) es
         siempre la unica candidata a cambiar. */
      var candidatoSiblings = tituloConfigurado('siblings');
      if (candidatoSiblings && tituloYaExisteEnPagina(selector, candidatoSiblings)) {
        titulo = tituloConfigurado('siblings_alt');
      } else {
        titulo = candidatoSiblings;
      }
    }

    var deseado = titulo ? titulo : '';
    var marcador = label.querySelector('[data-maha-titulo-grupo]');
    if (!deseado) {
      if (marcador && marcador.parentNode) marcador.parentNode.removeChild(marcador);
      return;
    }
    if (!marcador) {
      marcador = document.createElement('span');
      marcador.setAttribute('data-maha-titulo-grupo', '');
      label.appendChild(marcador);
    }
    if (marcador.textContent !== deseado) marcador.textContent = deseado;
  }

  /* MAHA 2026-09-14 -- SWATCH-UNA-FILA-UN-CRITERIO
     Decision de Guillermo (R1, "manda sobre todo lo demas"): dentro de UNA
     fila, todas las etiquetas salen del MISMO criterio -- o todas son
     medida, o todas son nombre. Se llama "fila de medida" si el nombre de
     la opcion es literalmente "Tamaño", O si TODOS los valores (no vacios)
     de la fila tienen una medida real segun recorta() -- basta con que UNO
     solo no la tenga para que la fila entera sea "de nombre" (ver la rama
     de nombre mas abajo, que ahora deja de intentar recorta() por swatch).
     No se toca recorta(): solo se pregunta, por cada valor, si ya da null
     o no -- la funcion no cambia una linea. */
  function esFilaDeMedida(selector, valoresCrudos) {
    var contOpcion = selector.closest('[option-name]');
    var nombre = contOpcion ? String(contOpcion.getAttribute('option-name') || '').trim().toLowerCase() : '';
    if (nombre === 'tamaño') return true;
    for (var i = 0; i < valoresCrudos.length; i++) {
      var v = valoresCrudos[i];
      if (v === null) continue; /* un valor vacio no decide nada por si solo */
      if (recorta(v) === null) return false;
    }
    return true;
  }

  /* MAHA 2026-09-14 -- SWATCH-UNA-FILA-UN-CRITERIO
     Variante de recortaComunGrupo() (esa NO se toca) que quita SOLO el
     prefijo compartido por TODOS, nunca el sufijo. Hace falta separada
     porque en una fila de medida el sufijo compartido suele ser la unidad
     misma ("cm", "ml"...) -- recortaComunGrupo() se la comeria junto con
     el prefijo (medido: "Cuchillo 22 cm".."Cuchara postre 13 cm" comparten
     "cm" al final; quitarla deja "22", numero suelto, justo la basura que
     esBasuraComun() ya prohibe, y encima viola R1: la etiqueta debe SER la
     medida, nunca un numero sin unidad). Se usa SOLO como desempate cuando
     dos medidas de la misma fila chocan (ver el uso en pintaSelector()) --
     el caso real: "Plato trinche Hygge 27 cm" y "Plato trinche 27 cm"
     comparten "Plato trinche" (2 palabras) pero NO "Hygge", asi que
     recorta() solo ("27 cm") no alcanza a distinguirlas; quitando nada mas
     el prefijo queda "Hygge 27 cm" vs "27 cm" -- unicas, y las dos con su
     medida completa intacta. */
  function soloPrefijoComun(valoresCrudos) {
    var listas = [], i, j;
    for (i = 0; i < valoresCrudos.length; i++) listas.push(palabras(valoresCrudos[i]));
    if (!listas.length) return valoresCrudos.slice();
    var minLen = listas[0].length;
    for (i = 1; i < listas.length; i++) { if (listas[i].length < minLen) minLen = listas[i].length; }
    var prefijoLen = 0;
    for (i = 0; i < minLen; i++) {
      var w = listas[0][i], iguales = true;
      for (j = 1; j < listas.length; j++) { if (listas[j][i] !== w) { iguales = false; break; } }
      if (!iguales) break;
      prefijoLen++;
    }
    return listas.map(function (l) {
      var restante = l.slice(prefijoLen).join(' ').trim();
      return restante ? restante : null;
    });
  }

  /* MAHA 2026-09-14 -- SWATCH-UNA-FILA-UN-CRITERIO
     Para una fila de NOMBRE (la que no califica como "de medida"): quita
     de cada valor las palabras que aparecen en MAS DE LA MITAD de sus
     hermanos de fila (mayoria estricta, no "todos" como
     recortaComunGrupo() -- esa exige unanimidad y en filas heterogeneas
     ("Platos trinche"/"Platos hondos"/"Ramekin...80 ml"/"Charolas...cm")
     da 0 casi siempre, porque no TODOS empiezan igual). Las palabras que
     sobran (la medida de cada quien, cuando la tiene) casi nunca son
     mayoria -- aparecen en 1 de N hermanos -- asi que sobreviven solas.
     Comparacion sin distinguir mayusculas/minusculas; el texto que se
     devuelve conserva las mayusculas originales. Si a un valor no le queda
     ninguna palabra, se devuelve null (mismo idioma que el resto: "nada
     que mostrar", que el llamador ya sabe manejar con su propio
     respaldo). No toca recortaComunGrupo() ni ninguna otra funcion. */
  function quitaPalabrasMayoria(valoresCrudos) {
    var listas = valoresCrudos.map(palabras);
    var n = listas.length;
    if (n < 2) return valoresCrudos.slice();
    var conteo = {}, i, j;
    for (i = 0; i < n; i++) {
      var vistas = {};
      for (j = 0; j < listas[i].length; j++) {
        var clave = listas[i][j].toLowerCase();
        if (vistas[clave]) continue; /* una sola vez por hermano, no por repeticion interna */
        vistas[clave] = true;
        conteo[clave] = (conteo[clave] || 0) + 1;
      }
    }
    return listas.map(function (l) {
      var restante = l.filter(function (w) { return conteo[w.toLowerCase()] <= n / 2; });
      return restante.length ? restante.join(' ') : null;
    });
  }

  /* MAHA 2026-09-11 -- SWATCH-QUITAR-LA-PARTE-REPETIDA-DE-LA-FILA
     Limite del recorte comun: "queda basura" si, tras quitar el prefijo y el
     sufijo compartidos, a un swatch le sobra una cadena vacia, un numero
     suelto sin unidad (recortaComunGrupo puede dejar exactamente eso: de
     "Plato trinche 27 cm" comun a sus hermanos en "Plato trinche" Y "cm" a
     la vez, sobra el "27" solo), o algo que termina en coma o en un
     conector/articulo suelto ("de", "y", "con", ...). Ninguna de las 7
     patrones de recorta() ni el resto de palabras() se toca: esto solo
     DECIDE si el resultado de recortaComunGrupo() se acepta o se descarta
     para ese swatch. */
  var CONECTOR_FINAL = /(?:^|\s)(de|del|y|o|u|e|con|para|en|a|al|la|el|los|las|un|una|sin|por)$/i;
  function esBasuraComun(texto) {
    if (texto === null) return true;
    var t = String(texto).trim();
    if (!t) return true;
    if (/,$/.test(t)) return true;
    if (/^\d+([.,]\d+)?$/.test(t)) return true;
    if (CONECTOR_FINAL.test(t)) return true;
    return false;
  }

  /* Envoltorio de una sola linea sobre las dos funciones de medida que ya
     existen: si el candidato cabe tal cual, se usa; si no, se acorta por
     palabra entera con masLargoQueQuepa() (nunca null, nunca a media
     palabra). No es logica nueva de recorte: solo ordena una verificacion
     que antes se repetia suelta en varios sitios. */
  function aseguraQueQuepa(cont, texto) {
    if (texto !== null && cabenTodos(cont, [texto])) return texto;
    return masLargoQueQuepa(cont, texto);
  }

  /* MAHA 2026-09-12 -- SWATCH-NO-DEJAR-PALABRA-COLGADA
     masLargoQueQuepa() corta por palabra ENTERA (nunca a la mitad), pero no
     sabe de gramatica: "Platos trinche de" es tres palabras completas y aun
     asi termina en preposicion. Esta funcion se corre DESPUES de cualquier
     recorte de la fila no-color (comun, recorta(), la cascada,
     masLargoQueQuepa(), o el nombre completo tal cual) y quita, en un bucle,
     la ultima palabra si es un conector/articulo/preposicion suelto, o una
     coma o guion sueltos al final -- y vuelve a revisar por si detras de esa
     palabra queda otra igual de colgada. Lista minima pedida: de, del, la,
     el, los, las, un, una, y, o, con, para, en, por, a, al, sin, sobre.
     Si limpiar deja cadena vacia, se devuelve el valor completo del propio
     swatch (nunca el de otro): el invariante de "ningun swatch sin texto"
     manda por encima de esto. No toca recorta(), recortaComunGrupo(),
     palabras() ni masLargoQueQuepa(): solo limpia lo que esas ya entregaron. */
  var PALABRA_COLGANTE = /^(de|del|la|el|los|las|un|una|y|o|con|para|en|por|a|al|sin|sobre)$/i;
  function quitaColgantes(texto, textoCompleto) {
    if (texto === null) return null;
    var t = String(texto).trim();
    while (true) {
      var sinPuntuacion = t.replace(/[,\-–—]+$/, '').trim();
      if (sinPuntuacion !== t) { t = sinPuntuacion; continue; }
      var ps = palabras(t);
      if (!ps.length) break;
      if (!PALABRA_COLGANTE.test(ps[ps.length - 1])) break;
      ps.pop();
      t = ps.join(' ');
    }
    return t ? t : textoCompleto;
  }

  /* ------------------------------------------------------------------------
     Pintado. Idempotente: si el <span> ya existe y su origen coincide con el
     texto actual del <p>, no se toca. Asi la propia escritura no se realimenta
     a traves del MutationObserver.
     ------------------------------------------------------------------------ */
  function pinta(raiz) {
    var selectores = raiz.querySelectorAll('.swatch-single');
    for (var i = 0; i < selectores.length; i++) pintaSelector(selectores[i]);
  }

  /**
   * ¿Este selector esta destapado?
   * NO se reimplementa aqui el umbral de los grupos: se CONSULTA el que decidio
   * assets/pdp-swatch-medida.css, que lo escribe una sola vez y lo publica en la
   * custom property `--maha-destapa`. Asi CSS y JS no pueden discrepar, y si
   * manana el tope cambia, se cambia solo en la hoja.
   * Si el CSS no cargo, o la ficha esta capada, o el navegador no soporta :has()
   * ni la anidacion, la propiedad viene vacia y aqui no se escribe nada -- que es
   * exactamente lo que hay que hacer: sin destape, un <span> nuestro solo serviria
   * para apagar el <p> de la app y encoger el bloque.
   */
  function destapado(selector) {
    try {
      return window.getComputedStyle(selector).getPropertyValue('--maha-destapa').trim() === '1';
    } catch (e) {
      return false;
    }
  }

  function limpia(selector) {
    var previos = selector.querySelectorAll('[' + MARCA + ']');
    for (var i = 0; i < previos.length; i++) {
      if (previos[i].parentNode) previos[i].parentNode.removeChild(previos[i]);
    }
    /* MAHA 2026-09-11 -- VARIANTE-POR-QUE-TARDA-AL-ELEGIR: si esta funcion
       corre es porque destapado(selector) dio false y se retiraron los
       <span> (ver pintaSelector()). Si se deja la firma cacheada de antes
       y despues destapado() vuelve a dar true con los MISMOS valores
       crudos, pintaSelector() creeria "nada cambio" y no volveria a
       pintar nada -- dejando la muestra sin <span> para siempre. Se borra
       la firma aqui para que, pase lo que pase despues, la proxima pasada
       con destapado=true recalcule de cero. */
    if (firmaPorSelector) firmaPorSelector.delete(selector);
  }

  /* MAHA 2026-09-11 -- VARIANTE-POR-QUE-TARDA-AL-ELEGIR
     CACHE DE FIRMA: medido en vivo que, tras UN clic de variante, el
     MutationObserver de observa() (subtree:true sobre un ancla tan ancha
     como .product-template/main) dispara pasada() unas 27 veces en ~5.5s
     (registrado via el atributo data-maha-medida-ok, que marcaSeguridad()
     reescribe en CADA pasada). La recarga de seccion mueve DOM que no
     tiene nada que ver con los swatches (galeria, apps, etc.), y cada
     disparo -- aunque el <span> resultante sea identico y no se reescriba
     por la guarda de idempotencia del bucle final -- vuelve a correr TODA
     la cascada de arriba (recorta/recortaComunGrupo/masLargoQueQuepa) y,
     dentro de esta, cabenTodos() con su sonda real (insertar nodo, medir
     con getBoundingClientRect -- fuerza reflow sincrono -- retirar nodo),
     varias veces por swatch. Eso, multiplicado por ~15 swatches en la
     pagina y ~27 pasadas, es el tiempo medido entre que la red ya
     respondio (~500ms) y que el precio cambia en pantalla (~3.8-5.5s).
     ARREGLO: guardar, por selector, la firma de los valores CRUDOS que ya
     se proceso la ULTIMA VEZ que esta funcion realmente hizo trabajo. Si
     la firma no cambio, no hay nada nuevo que medir ni que pintar -- se
     sale de inmediato, antes de leer un solo <p> de mas o de crear una
     sola sonda. No cambia NINGUN texto final: el mismo resultado que ya
     estaba pintado se queda exactamente igual, solo se deja de recalcular
     cuando el insumo (los valores crudos del <p> de cada muestra) es
     identico al de la ultima vez. No toca recorta(), recortaComunGrupo(),
     cabenTodos(), masLargoQueQuepa(), quitaColgantes() ni el bucle final:
     ninguna de esas funciones se borra ni se edita, esto solo decide SI
     se llega a llamarlas. */
  var firmaPorSelector = (typeof WeakMap === 'function') ? new WeakMap() : null;

  function pintaSelector(selector) {
    var conts = selector.querySelectorAll(CONTENEDOR);
    if (!conts.length) return;

    if (!destapado(selector)) { limpia(selector); return; }

    var candidatos = [], i;
    for (i = 0; i < conts.length; i++) {
      var p = conts[i].querySelector('p');           /* solo LECTURA del <p> */
      if (!p) continue;
      candidatos.push({ cont: conts[i], valor: p.textContent });
    }

    if (firmaPorSelector) {
      var firmaActual = candidatos.map(function (c) { return c.valor; }).join('');
      if (firmaPorSelector.get(selector) === firmaActual) return;
    }

    /* MAHA 2026-09-14 -- TITULO-DE-LAS-FILAS-DE-GRUPO
       Se pinta ANTES de decidir medidas[]: el titulo de la fila no depende
       de que rama de la cascada de abajo termine usandose, solo de si la
       fila tiene nombre real y de sus valores crudos -- los mismos que ya
       se acaban de leer arriba. Detras de firmaPorSelector: si los valores
       crudos no cambiaron, tampoco hace falta recalcular el titulo. */
    pintaTituloDeGrupo(selector, candidatos.map(function (c) { return c.valor; }));

    /* MAHA 2026-09-09 -- el grupo de color no usa recorta(): sus valores no
       tienen unidad, tienen una palabra distinta por muestra. Ver
       recortaComunGrupo() y esGrupoColor() mas arriba. */
    var medidas;
    if (esGrupoColor(selector)) {
      medidas = recortaComunGrupo(candidatos.map(function (c) { return c.valor; }));
    } else if (esFilaDeMedida(selector, candidatos.map(function (c) { return c.valor; }))) {
      /* MAHA 2026-09-14 -- SWATCH-UNA-FILA-UN-CRITERIO (R1 + R2 aprobados)
         Fila de medida: la etiqueta ES la medida, buscada en cualquier
         parte del valor (recorta() ya lo hace asi, no se toca). Si un
         valor no tiene medida (no deberia pasar en una fila "de medida",
         pero el invariante "ningun swatch sin texto" manda igual), ese
         swatch usa su nombre completo, ajustado a que quepa -- nunca se
         tapa ni se deja vacio.
         Colision (R2, SOLO como desempate, nunca por delante de R1): si
         dos medidas de la fila coinciden -- caso real, "Plato trinche
         Hygge 27 cm" y "Plato trinche 27 cm" comparten "27 cm" -- se
         quita el prefijo compartido por TODOS (soloPrefijoComun(), nunca
         el sufijo/unidad) y se usa lo que quede, siempre que siga
         conteniendo la medida real; si no la contiene (no deberia pasar:
         soloPrefijoComun nunca toca el sufijo), se cae a la medida sola.
         Este desempate NUNCA se dispara si las medidas ya son unicas --
         por eso "Tamaño" de VZ210-05 (22/21.5/15/21/13 cm, todas
         distintas) sale exactamente igual que hoy, sin pasar por aqui. */
      medidas = candidatos.map(function (c) {
        var m = recorta(c.valor);
        return m !== null ? m : aseguraQueQuepa(c.cont, c.valor);
      });
      var vistosMedida = {}, chocaMedida = false, medidasNoNulas = [];
      for (i = 0; i < candidatos.length; i++) {
        var medidaI = recorta(candidatos[i].valor);
        if (medidaI !== null) {
          medidasNoNulas.push(medidaI);
          if (vistosMedida[medidaI]) chocaMedida = true;
          vistosMedida[medidaI] = true;
        }
      }
      if (chocaMedida) {
        /* MAHA 2026-09-14 -- SWATCH-LA-MEDIDA-SOLO-VALE-SI-DISTINGUE
           La invariante de arriba (R1) decia "si el valor trae medida, la
           etiqueta la conserva" a secas. Guillermo la corrigio: la medida
           solo vale la pena conservarla a la fuerza cuando DISTINGUE a la
           muestra de sus hermanas de fila. Hay dos formas muy distintas de
           chocar y hay que tratarlas distinto:
             - COLISION PARCIAL: unas medidas se repiten, otras no (caso
               real Hygge: 27/23/21/27/23 cm -- 3 valores distintos entre
               5 muestras). Ahi la medida SI distingue a la mayoria y solo
               hace falta desempatar con el prefijo -- eso ya funcionaba
               (ver el "else" de abajo, sin tocar una linea).
             - MEDIDA UNIFORME: TODAS las medidas no vacias de la fila son
               la MISMA cadena (caso real Rioja: las 5 copas dan "470 ml").
               Ahi la medida no distingue a NADIE -- es un dato compartido
               por toda la fila, igual que el prefijo "Copa de cristal".
               Forzar su presencia (como hacia el codigo viejo via
               soloPrefijoComun + el indexOf(medidaReal)) le quita a
               masLargoQueQuepa() el espacio que necesitaba para llegar al
               dato que si distingue ("transparente para vino tinto"),
               dejando algo TRUNCADO A MEDIA FRASE y sin la medida de
               todos modos, porque cabenTodos() nunca alcanzaba a incluirla. */
        var distintasMedida = Object.keys(vistosMedida).length;
        var medidaUniforme = medidasNoNulas.length >= 2 && distintasMedida === 1;
        if (medidaUniforme) {
          /* la medida es sufijo comun (no distingue): se quita junto con
             el resto de lo comun. recortaComunGrupo() no se toca: ya
             quita, por PALABRA completa, el prefijo Y el sufijo
             compartidos por TODOS los valores de la fila -- la medida
             identica cae ahi sola, sin necesitar logica nueva para ella. */
          var comunUniforme = recortaComunGrupo(candidatos.map(function (c) { return c.valor; }));
          var vistosCU = {}, chocaCU = false;
          for (i = 0; i < candidatos.length; i++) {
            var cu = comunUniforme[i];
            if (cu !== null && !esBasuraComun(cu)) {
              if (vistosCU[cu]) chocaCU = true;
              vistosCU[cu] = true;
            }
          }
          if (!chocaCU) {
            medidas = candidatos.map(function (c, idx) {
              var cnd = comunUniforme[idx];
              if (cnd === null || esBasuraComun(cnd)) return aseguraQueQuepa(c.cont, c.valor);
              return aseguraQueQuepa(c.cont, cnd);
            });
            for (i = 0; i < medidas.length; i++) medidas[i] = quitaColgantes(medidas[i], candidatos[i].valor);
          } else {
            /* lo comun tambien choca entre si: unico camino que queda sin
               inventar nada es el valor completo de cada quien, ajustado
               a que quepa -- mismo respaldo que ya usa la rama de nombre
               un poco mas abajo (chocaComun). */
            medidas = candidatos.map(function (c) { return aseguraQueQuepa(c.cont, c.valor); });
          }
        } else {
          /* COLISION PARCIAL -- codigo sin cambios (R2, solo desempate,
             conserva la medida real; no se dispara con medidas ya unicas,
             por eso "Tamaño" de VZ210-05 no pasa por ningun lado de este
             bloque: chocaMedida ya sale false para esa fila). */
          var sinPrefijoMedida = soloPrefijoComun(candidatos.map(function (c) { return c.valor; }));
          medidas = candidatos.map(function (c, idx) {
            var medidaReal = recorta(c.valor);
            if (medidaReal === null) return aseguraQueQuepa(c.cont, c.valor);
            var candidatoSinPrefijo = sinPrefijoMedida[idx];
            if (candidatoSinPrefijo && candidatoSinPrefijo.indexOf(medidaReal) !== -1) {
              return aseguraQueQuepa(c.cont, candidatoSinPrefijo);
            }
            return aseguraQueQuepa(c.cont, medidaReal);
          });
        }
      }
    } else {
      /* MAHA 2026-09-09 -- SWATCH-TEXTO-HIBRIDO-POR-FILA. Decision de Guillermo.
         Ni completo siempre ni medida siempre: se decide FILA POR FILA.
           - si TODOS los nombres de la fila caben en el tope de renglones a
             54 px sin cortarse -> la fila usa el NOMBRE COMPLETO
           - si UNO SOLO no cabe -> la fila ENTERA usa recorta()
         La fila nunca se mezcla: dos vecinas con criterio distinto se ven peor
         que cualquiera de las dos opciones.
         El grupo de COLOR no pasa por aqui (ver la rama de arriba):
         recortaComunGrupo(), sin tocar.
         MAHA 2026-09-10 -- el tope es 3 renglones (antes 2), ver cabenTodos()
         y el `-webkit-line-clamp` de [data-maha-medida] en el CSS -- los dos
         numeros viven en un solo sitio cada uno y deben coincidir. */
      var completos = candidatos.map(function (c) {
        var t = String(c.valor == null ? '' : c.valor).trim();
        return t === '' ? null : t;
      });

      /* MAHA 2026-09-11 -- SWATCH-QUITAR-LA-PARTE-REPETIDA-DE-LA-FILA
         recortaComunGrupo() (sin tocar) corre PRIMERO en CUALQUIER fila no-
         color, antes de preguntar si el nombre completo cabe. Si los valores
         de la fila comparten de verdad un prefijo o un sufijo -- la funcion
         sigue exigiendo que lo compartan TODOS, eso no cambia -- se pinta lo
         que queda. Si NO comparten nada (recortaComunGrupo devuelve los
         valores intactos), esta rama no hace nada y sigue el camino de
         siempre unas lineas mas abajo. */
      var comunesFila = recortaComunGrupo(completos.map(function (t) { return t || ''; }));
      var huboComun = false;
      for (i = 0; i < completos.length; i++) {
        if (completos[i] !== null && comunesFila[i] !== null && comunesFila[i] !== completos[i]) { huboComun = true; break; }
      }

      /* MAHA 2026-09-11 -- SWATCH-EL-COMUN-SOLO-VALE-SI-CABE
         El recorte comun de arriba se usa SOLO SI, para cada swatch que no
         cae en "basura" (ver mas abajo), lo que queda CABE en el tope de
         renglones vigente -- verificado con la MISMA sonda de cabenTodos(),
         sin shrink de por medio (masLargoQueQuepa() no entra en esta
         decision: si hace falta acortar por palabra, es que el comun no
         cabia de por si, y entonces el comun completo se descarta para TODA
         la fila, no solo para ese swatch). Caso real que esto arregla:
         "Vaso"..."ml" es comun a los 4 valores de un vaso, pero lo que
         sobra en medio es el titulo entero del producto -- no cabe, se
         descarta, y la fila cae exactamente al mismo camino que sin comun
         (recorta() por swatch), que es lo que ya funcionaba. */
      if (huboComun) {
        var comunCabeEntero = true;
        for (i = 0; i < completos.length; i++) {
          if (completos[i] === null) continue;
          var comunI = comunesFila[i];
          if (esBasuraComun(comunI)) continue; /* este swatch usara recorta(), no decide si el comun cabe */
          if (!cabenTodos(candidatos[i].cont, [comunI])) { comunCabeEntero = false; break; }
        }
        if (!comunCabeEntero) huboComun = false;
      }

      if (huboComun) {
        /* Limite del recorte, en orden:
           1. Si lo que queda es basura para un swatch (vacio, un numero
              suelto sin unidad, o termina en coma/conector), ESE swatch cae
              a la cascada de siempre sobre su propio valor completo -- no al
              nombre completo a secas. Ejemplo real: "Plato trinche 27 cm"
              comparte "Plato trinche" (prefijo) Y "cm" (sufijo) con sus
              hermanos, y recortaComunGrupo dejaria solo "27" (numero suelto:
              basura). recorta("Plato trinche 27 cm") ya da "27 cm" -- la
              cascada existente resuelve exactamente este caso.
           2. Si dos swatches de la fila quedan con el MISMO texto tras esto,
              TODA la fila vuelve a su nombre completo (asegurado a que
              quepa en el tope de renglones vigente).
           El comun ya se confirmo arriba que cabe (para los swatches que no
           son basura), asi que aqui no hace falta masLargoQueQuepa() sobre
           el: se usa tal cual. */
        var candidatosComun = candidatos.map(function (c, idx) {
          var comun = comunesFila[idx];
          if (esBasuraComun(comun)) {
            var m = recorta(c.valor);
            if (m !== null) return aseguraQueQuepa(c.cont, m);
            return aseguraQueQuepa(c.cont, completos[idx]);
          }
          return comun;
        });

        var vistosComun = {}, chocaComun = false;
        for (i = 0; i < candidatosComun.length; i++) {
          if (candidatosComun[i] !== null) {
            if (vistosComun[candidatosComun[i]]) chocaComun = true;
            vistosComun[candidatosComun[i]] = true;
          }
        }

        if (chocaComun) {
          medidas = candidatos.map(function (c, idx) { return aseguraQueQuepa(c.cont, completos[idx]); });
        } else {
          medidas = candidatosComun;
        }
      } else if (candidatos.length && cabenTodos(candidatos[0].cont, completos)) {
        /* MAHA 2026-09-09 -- SWATCH-TEXTO-HIBRIDO-POR-FILA. Decision de Guillermo.
           Ni completo siempre ni medida siempre: se decide FILA POR FILA.
             - si TODOS los nombres de la fila caben en el tope de renglones a
               54 px sin cortarse -> la fila usa el NOMBRE COMPLETO
             - si UNO SOLO no cabe -> la fila ENTERA usa recorta()
           La fila nunca se mezcla: dos vecinas con criterio distinto se ven peor
           que cualquiera de las dos opciones.
           MAHA 2026-09-10 -- el tope es 3 renglones (antes 2), ver cabenTodos()
           y el `-webkit-line-clamp` de [data-maha-medida] en el CSS -- los dos
           numeros viven en un solo sitio cada uno y deben coincidir. */
        medidas = completos;
      } else {
        /* MAHA 2026-09-10 -- SWATCH-LOS-GRUPOS-DE-PRODUCTO-QUEDARON-SIN-NOMBRE
           recorta() solo encuentra una MEDIDA (unidad: cm/ml/oz/...). En las
           filas que saltan a productos hermanos (la opcion no tiene nombre:
           no es un "Tamaño" ni una "Variante de X" real, es la matriz de la
           app), el valor crudo suele ser el TITULO del producto sin ninguna
           unidad -- "Platos trinche de ceramica blanco Barcelona" no tiene
           cm ni ml, recorta() da null, y esa muestra se quedaba en blanco (el
           <p> nativo tambien se oculta sin hermano, ver el CSS). Invariante
           duro: ningun swatch sin texto. Se prueban, en orden, las funciones
           que ya existen -- ninguna se toca -- y cada candidato se verifica
           con la misma sonda (cabenTodos con un arreglo de un elemento) antes
           de aceptarlo:
             1. recorta(): si encuentra unidad y cabe, esa gana (no cambia
                nada para filas que ya funcionan, como "Tamaño").
             2. recortaComunGrupo(): la misma funcion del grupo de color,
                sobre los valores completos de este renglon (ya se probo
                arriba y no dio nada: esta repeticion es inofensiva, no
                reescribe nada, solo vuelve a llamar la misma funcion pura).
             3. masLargoQueQuepa(): el titulo completo, recortado por palabra
                entera (nunca a la mitad) hasta que quepa.
           Este orden nunca deja null: masLargoQueQuepa() siempre devuelve
           algo, aunque sea una sola palabra.

           MAHA 2026-09-14 -- SWATCH-UNA-FILA-UN-CRITERIO: llegar hasta
           aqui YA significa que esFilaDeMedida() dio false para toda la
           fila (ver la nueva rama, arriba de esta) -- es decir, al menos
           un hermano no tiene medida, asi que la fila entera va por
           NOMBRE (R1: un solo criterio por fila). El paso 1 de la lista
           de arriba (recorta() por swatch) por eso YA NO se prueba aqui:
           dejaba filas mixtas ("Platos trinche"/"Platos hondos"/"80 ml"/
           "30.5 x 17.5 cm", medido en vivo el 2026-09-11) con dos
           criterios a la vez. En su lugar se prueba primero
           quitaPalabrasMayoria() (nueva, ver arriba): quita lo que
           comparten MAS DE LA MITAD de los hermanos ("de"/"melamina"/
           "café"/"Beluga" en el caso real) y deja fragmentos ya
           unicos -- la medida de quien la tenga sobrevive sola porque
           nunca es mayoria. recorta() NO se borro ni se edito: sigue
           intacta, solo se dejo de llamar en ESTE paso especifico. */
        var comunes = null;
        var mayoriaFila = quitaPalabrasMayoria(candidatos.map(function (cc) { return cc.valor; }));
        medidas = candidatos.map(function (c, i) {
          var m = mayoriaFila[i];
          if (m !== null && !esBasuraComun(m) && cabenTodos(c.cont, [m])) return m;
          if (comunes === null) {
            comunes = recortaComunGrupo(candidatos.map(function (cc) { return cc.valor; }));
          }
          var comun = comunes[i];
          if (comun && cabenTodos(c.cont, [comun])) return comun;
          return masLargoQueQuepa(c.cont, completos[i]);
        });
      }

      /* MAHA 2026-09-12 -- SWATCH-NO-DEJAR-PALABRA-COLGADA
         Tras CUALQUIER recorte de esta rama -- comun, recorta(), la cascada,
         masLargoQueQuepa(), o el nombre completo usado tal cual -- si lo que
         quedo termina en conector/articulo/preposicion, coma o guion, se
         quita, y se vuelve a revisar por si detras queda OTRA colgada
         ("Platos trinche de" -> quita "de" -> "Platos trinche", que ya no
         termina en nada de la lista, para ahi). Si limpiar deja cadena
         vacia, se devuelve el valor completo -- el invariante de "ningun
         swatch sin texto" manda por encima de esto tambien. */
      for (i = 0; i < medidas.length; i++) {
        medidas[i] = quitaColgantes(medidas[i], completos[i]);
      }

      /* MAHA 2026-09-11 -- SWATCH-EL-COMUN-SOLO-VALE-SI-CABE: invariante de
         la medida, por encima de CUALQUIER regla de recorte de esta rama
         (comun, cascada, masLargoQueQuepa). Si el valor original de un
         swatch trae una medida real -- recorta() la encuentra -- el texto
         final tiene que conservarla, la haya escrito el camino que la haya
         escrito. Si no la conserva, se sustituye por la medida misma: es
         corta y ya paso por recorta(), asi que siempre cabe. No aplica al
         grupo de color (esa rama ni entra aqui: termina arriba, en el
         `if (esGrupoColor(selector))`). */
      for (i = 0; i < candidatos.length; i++) {
        var medidaEsperada = recorta(candidatos[i].valor);
        if (medidaEsperada !== null) {
          var actual = medidas[i];
          if (actual === null || actual.indexOf(medidaEsperada) === -1) {
            medidas[i] = aseguraQueQuepa(candidatos[i].cont, medidaEsperada);
          }
        }
      }
    }

    var items = [], vistos = {}, choca = false, it;
    for (i = 0; i < candidatos.length; i++) {
      var medida = medidas[i];
      if (medida !== null) {
        if (vistos[medida]) choca = true;
        vistos[medida] = true;
      }
      items.push({ cont: candidatos[i].cont, valor: candidatos[i].valor, medida: medida });
    }

    /* TERCERA GUARDIA: la etiqueta esta para DISTINGUIR una muestra de otra.
       Si dos muestras del MISMO selector se recortarian al mismo texto, el
       recorte deja de servir. Pasa en los grupos de color: "Plato trinche rosa
       Mexico Lindo 27 cm", "... morado ...", "... azul ..." dan las tres
       "27 cm". Cuando eso ocurre no se recorta NINGUNA de ese selector y se
       ven los valores completos, con su color. */
    for (i = 0; i < items.length; i++) {
      it = items[i];
      var salida = choca ? null : it.medida;
      var span = it.cont.querySelector('[' + MARCA + ']');

      if (salida === null) {
        /* nada que recortar: se retira nuestro hermano si lo hubiera, y la
           etiqueta nativa vuelve a verse entera (D4) */
        if (span && span.parentNode) span.parentNode.removeChild(span);
        continue;
      }
      if (span && span.getAttribute(ORIGEN) === it.valor) continue;

      if (!span) {
        span = document.createElement('span');
        span.setAttribute(MARCA, '');
        /* la app sube por el DOM mientras el nodo tenga este atributo */
        span.setAttribute('swatch-inside', 'true');
        /* el nombre accesible ya lo dan li[aria-label] y span[role=img]:
           el recorte es decoracion visual, no debe leerse dos veces */
        span.setAttribute('aria-hidden', 'true');
        it.cont.appendChild(span);
      }
      span.setAttribute(ORIGEN, it.valor);
      span.setAttribute('title', String(it.valor).trim());
      span.textContent = salida;

      /* MAHA 2026-09-14 -- SWATCH-LA-MEDIDA-SOLO-VALE-SI-DISTINGUE, CAMBIO 2
         Ninguna palabra se parte por dentro. Se prueba 11px (el tamano base:
         sin marca, para que la regla [data-maha-medida] normal del CSS
         mande); si la palabra mas ancha de ESTA etiqueta no cabe sola en un
         renglon, se baja a 10 y luego a 9 -- el primero que le alcance,
         gana, y solo esta etiqueta recibe la marca (ninguna otra cambia de
         tamano). Si ni a 9px cabe, se deja en 9px (el piso pedido) y se
         reporta la palabra por consola: de ahi para arriba se permite el
         overflow-wrap:break-word que ya trae la regla base. */
      var pruebaBase = palabraMasAnchaCabe(it.cont, salida, null);
      if (pruebaBase.cabe) {
        span.removeAttribute(TAMANO_ATTR);
      } else {
        var prueba10 = palabraMasAnchaCabe(it.cont, salida, '10');
        if (prueba10.cabe) {
          span.setAttribute(TAMANO_ATTR, '10');
        } else {
          var prueba9 = palabraMasAnchaCabe(it.cont, salida, '9');
          span.setAttribute(TAMANO_ATTR, '9');
          if (!prueba9.cabe) {
            try {
              console.warn('[maha-medida] la palabra "' + prueba9.palabra + '" no cabe ni a 9px en la etiqueta "' + salida + '"');
            } catch (e) { /* consola ausente: no rompe el pintado */ }
          }
        }
      }
    }

    /* MAHA 2026-09-11 -- VARIANTE-POR-QUE-TARDA-AL-ELEGIR: se guarda la
       firma DESPUES de terminar el trabajo (nunca antes: si algo de arriba
       lanzara, pasada() ya lo atrapa en su propio try/catch, y esta linea
       no correria -- la proxima pasada real vuelve a intentarlo desde
       cero, no se queda con una firma de un intento a medias). */
    if (firmaPorSelector) firmaPorSelector.set(selector, firmaActual);
  }

  /* ------------------------------------------------------------------------
     Enganche. Un MutationObserver por cada <variant-swatch-king>, que es el
     unico ancla estable. Nada de presets ni de indices de grupo.
     ------------------------------------------------------------------------ */
  var pendiente = false;

  function programa() {
    if (pendiente) return;
    pendiente = true;
    var luego = function () { pendiente = false; pasada(); };
    /* rAF llamado sin su receptor lanza "Illegal invocation" en varios motores */
    if (typeof window.requestAnimationFrame === 'function') {
      window.requestAnimationFrame(luego);
    } else {
      window.setTimeout(luego, 16);
    }
  }

  /* MAHA 2026-09-09 -- RED DE SEGURIDAD (SWATCH-MEDIDA-ESTA-ROTO)
     El 2026-09-09 la ficha se quedo SIN NINGUNA etiqueta visible: ni la nuestra
     ni la de la app. La causa del efecto compuesto esta en el CSS: la regla
     `.swatch-img-text:not(:has(> [data-maha-medida])) > p { display:none }`
     oculta el <p> nativo cuando NO hay hermano nuestro, y CSS por si solo no
     puede distinguir "corri y decidi no crear el span" (colision, correcto) de
     "no llegue a correr" (fallo, y entonces no se ve nada).
     Aqui se le da esa informacion: tras cada pasada se cuenta cuantos
     [data-maha-medida] hay en la pagina y se marca <html> con
     `data-maha-medida-ok` solo si hay al menos uno. El CSS cuelga de esa marca.
     Si el JS no corre, la marca no existe, la regla de ocultar no aplica y se ve
     la etiqueta nativa completa: texto largo, pero VISIBLE. Vale mas ver el
     texto largo que no ver nada.
     No toca recorta(), ni sus patrones, ni sus guardias. */
  function marcaSeguridad() {
    try {
      var hay = document.querySelectorAll('[' + MARCA + ']').length > 0;
      var raiz = document.documentElement;
      if (hay) raiz.setAttribute('data-maha-medida-ok', '');
      else raiz.removeAttribute('data-maha-medida-ok');
    } catch (e) { /* si esto falla, la marca no se pone: se ve el <p> nativo */ }
  }

  function pasada() {
    try {
      var raices = document.querySelectorAll(RAIZ);
      for (var i = 0; i < raices.length; i++) pinta(raices[i]);
    } catch (e) {
      /* silencio deliberado: nada de lo que pase aqui puede tumbar la PDP */
    }
    /* FUERA del try de arriba a proposito: aunque pinta() haya lanzado a mitad,
       la marca tiene que reflejar lo que hay REALMENTE en el DOM. */
    marcaSeguridad();
  }

  function observa(nodo) {
    if (nodo.__mahaMedidaObs) return;
    nodo.__mahaMedidaObs = true;
    try {
      new MutationObserver(programa).observe(nodo, { childList: true, subtree: true });
    } catch (e) { /* sin observer, al menos queda la pasada inicial */ }
  }

  function conecta() {
    var raices = document.querySelectorAll(RAIZ);
    for (var i = 0; i < raices.length; i++) observa(raices[i]);
    return raices.length;
  }

  /* MAHA 2026-09-09 -- SWATCH-MEDIDA-EL-DISPARO-NO-ES-EL-CODIGO
     ANCLA ESTABLE. Antes solo se observaba <variant-swatch-king>, y eso deja dos
     agujeros medidos:
       1. Si el elemento YA existe al arrancar, conecta() devuelve >0 y el vigia
          sobre documentElement no se instalaba nunca. Si despues la app
          REEMPLAZA ese nodo, el observador se queda pegado al huerfano.
       2. Si el contenido ya venia completo en el HTML, no hay ninguna mutacion
          posterior que disparar -- y si en esa primera pasada la hoja de estilos
          aun no habia aplicado, `--maha-destapa` se lee vacia, la compuerta
          cierra, y no queda nada que vuelva a intentarlo.
     El ancla es un ancestro que existe SIEMPRE y que no se reemplaza. Se observa
     con subtree:true, asi que cubre los dos casos sin depender de que
     <variant-swatch-king> exista ya. */
  function anclaEstable() {
    var candidatos = ['[id^="shopify-section"][id$="__main"]', '.product-template', 'main', '#MainContent'];
    for (var i = 0; i < candidatos.length; i++) {
      var n = document.querySelector(candidatos[i]);
      if (n) return n;
    }
    return document.body || document.documentElement;
  }

  /* MAHA 2026-09-09 -- REINTENTO ACOTADO.
     Cubre el caso que ningun observador puede cubrir: el contenido ya estaba en
     el HTML (no hay mutacion que observar) pero la hoja de estilos aun no habia
     aplicado, asi que `--maha-destapa` se leyo vacia y la compuerta cerro.
     TOPES DUROS, por encargo: 10 intentos como maximo, uno por segundo como
     maximo. No es setInterval: cada intento programa el siguiente con
     setTimeout y solo si queda cupo, asi que no puede quedarse vivo.
     PARA SOLO cuando:
       - ya hay al menos una etiqueta pintada, o
       - la hoja aplico (--maha-destapa tiene valor) y la app ya trajo su <p>:
         entonces la decision de no pintar es deliberada (colision o tope de
         grupos), no un fallo de tiempo, y reintentar no cambiaria nada.
     Correr de mas es inofensivo: pintaSelector() es idempotente por
     data-maha-src, no duplica ni reescribe lo ya puesto. */
  var INTENTOS_MAX = 10;
  var ESPERA_MS = 1000;
  var intentos = 0;
  var reintentoProgramado = false;

  function yaResuelto() {
    try {
      if (document.querySelectorAll('[' + MARCA + ']').length > 0) return true;
      var s = document.querySelector('.swatch-single');
      if (!s) return false;
      var hojaAplicada = window.getComputedStyle(s).getPropertyValue('--maha-destapa').trim() !== '';
      var hayP = document.querySelector(CONTENEDOR + ' p') !== null;
      return hojaAplicada && hayP;
    } catch (e) { return false; }
  }

  function reintenta() {
    if (reintentoProgramado) return;
    if (intentos >= INTENTOS_MAX) return;
    reintentoProgramado = true;
    window.setTimeout(function () {
      reintentoProgramado = false;
      intentos++;
      conecta();          /* por si el elemento aparecio o lo reemplazaron */
      pasada();
      if (!yaResuelto()) reintenta();
    }, ESPERA_MS);
  }

  function arranca() {
    try {
      conecta();
      /* El ancla se observa SIEMPRE, exista ya <variant-swatch-king> o no.
         Sustituye al vigia de antes, que solo se instalaba si el elemento
         faltaba. Se apaga a los 30 s como antes. */
      var ancla = anclaEstable();
      if (ancla && !ancla.__mahaMedidaAncla) {
        ancla.__mahaMedidaAncla = true;
        var obsAncla = new MutationObserver(function () { conecta(); programa(); });
        obsAncla.observe(ancla, { childList: true, subtree: true });
        setTimeout(function () { try { obsAncla.disconnect(); } catch (e) {} }, 30000);
      }
      pasada();
      if (!yaResuelto()) reintenta();
    } catch (e) { /* silencio deliberado */ }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arranca);
  } else {
    arranca();
  }
})();
